import component from './component.vue';
import FItemObject from '../FItem/Object';

export default class FTourist extends FItemObject {
  __component = component;

  constructor(props) {
    super(props);
    this.set();
  }


  set(value = {}) {
    super.set({
      adult: value.adult || 0,
      child: value.child || [],
    });
  }
}
